module.exports = __webpack_public_path__ + "static/img/n-boy.3b6e136.png";


//////////////////
// WEBPACK FOOTER
// ./static/skin/default/APP/Campus/Location/TeacherLocation/img/n-boy.png
// module id = ADRj
// module chunks = 557